function Close({ fill, size }: string | any | { fill: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "25"}
      height={size ? size : "25"}
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill={fill ? fill : "#2c2c2c"}
        d="M18.8 6.682a.996.996 0 00-1.41 0l-4.89 4.88-4.89-4.89a.996.996 0 10-1.41 1.41l4.89 4.89-4.89 4.89a.996.996 0 101.41 1.41l4.89-4.89 4.89 4.89a.996.996 0 101.41-1.41l-4.89-4.89 4.89-4.89c.38-.38.38-1.02 0-1.4z"
      ></path>
    </svg>
  );
}

export default Close;
